module.exports = __webpack_public_path__ + "fonts/Lexend-100-vietnamese1.f7c8cc8.woff2";